<template>
  <v-card max-width="500" min-width="300" class="pt-6 px-4 pb-1">
    <template v-if="card=='select'">
      <v-card-title>Välj hur du vill logga in</v-card-title>
      <v-list class="mt-2">
        <v-list-item @click="doExternalLogin()">
          <v-list-item-content>
            <v-list-item-title>BankID</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>$sl-arrow-right</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-list-item @click="showCard('email')">
          <v-list-item-content>
            <v-list-item-title>E-postadress och lösenord</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>$sl-arrow-right</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-card-text class="body-1 mt-n3">Har du problem att logga in? Ring BYN:s kansli.</v-card-text>
    </template>

    <template v-if="card=='email'">      
        <v-btn text @click="showCard('select')" class="ml-3 mt-n1"><v-icon x-small>$sl-arrow-left</v-icon> Tillbaka</v-btn>      
        <login-card-email />
    </template>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import API from '@/services/api'
import LoginCardEmail from '@/components/LoginCardEmail'
// @group Common
// LoginDeck component
export default {
  name: 'LoginDeck',

  data: () => ({
    card: 'select'
  }),

  components: {
    LoginCardEmail
  },

  methods: {
     /**
       * @vuese
       * Used to external login in the system 
       * @arg The argument is hashed
       */
    doExternalLogin() {
      console.log('LoginDeck - doExternalLogin')

      API.bankIdExternal({callback: Buffer.from(window.location.protocol + '//' + window.location.host + '/loginreturn').toString('base64')})
        .then(res => {
          
          if (res.data.redirectUrl) {
            window.location = res.data.redirectUrl 
          }
        })
        .catch(err => {
          console.log("Error: ",err)
        })
    },

    showCard(cardname) {
      this.card = cardname
    }
  }
}
</script>

<style lang="scss" scoped>
.v-list-item {
  border: 1px solid lightgrey !important;
  margin: 3px 10px 3px 10px !important;
}
</style>